import api from './api';

export async function getUserPersonalData() {
  return api.get('/users/personal').then(res => res.data);
}

export function putUserAddress(address) {
  return api.put('/users/customer', address).then(res => res.data);
}
